import PropTypes from 'prop-types'

import { AppContainer } from '../Elements/Container'
import { Head, HeadDevelop } from '../Head'

const ContentLayout = ({
    title,
    errorTitle,
    fluid = false,
    // searchResult = false,
    children,
    bg = 'white',
}) => {
    return (
        <AppContainer fluid={fluid} py={0} bg={bg}>
            <Head title={title} errorTitle={errorTitle} />
            {children}
        </AppContainer>
    )
}

ContentLayout.propTypes = {
    title: PropTypes.string,
    errorTitle: PropTypes.string,
    fluid: PropTypes.bool,
    searchResult: PropTypes.bool,
    children: PropTypes.node,
}

const ContentLayoutDevelop = ({
    title,
    errorTitle,
    fluid = false,
    children,
    bg = 'white',
}) => {
    return (
        <AppContainer fluid={fluid} py={0} bg={bg}>
            <HeadDevelop title={title} errorTitle={errorTitle} />
            {children}
        </AppContainer>
    )
}

ContentLayoutDevelop.propTypes = {
    title: PropTypes.string,
    errorTitle: PropTypes.string,
    fluid: PropTypes.bool,
    children: PropTypes.node,
}

export { ContentLayout, ContentLayoutDevelop }
